import React, { Component } from "react"

class Footer extends Component {

    render() {

        return (
            <div>
                 <footer id="footer">
    <div class="container">
      <h3>AbUtEcH bRo</h3>
      <p>A Passionate Personnel</p>
      <div class="social-links">
        <a href="https://twitter.com/AbUtEcH_bRo" class="twitter"><i class="bx bxl-twitter"></i></a>
        <a href="https://instagram.com/AbUtEcH_bRo" class="instagram"><i class="bx bxl-instagram"></i></a>
        <a href="https://github.com/Abutechbro" class="google-plus"><i class="bx bxl-github"></i></a>
      </div>
      <div class="copyright">
        &copy; Copyright <strong><span>AbUtEcH bRo</span></strong>. All Rights Reserved
      </div>
      <div class="credits">
      </div>
    </div>
  </footer>
            </div>

)

    }

}

export default Footer;